import {
  Modal,
  Select,
  Input,
  Button,
  Form,
  message,
  Card,
  Row,
  Col,
  notification,
} from "antd";
import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import dateChangeService from "services/bookingdateChangeService";
import {
  PlusOutlined,
  UploadOutlined,
  CloseCircleOutlined,
  MinusCircleOutlined,
} from "@ant-design/icons";
import ImageUploader from "./CroppingSection";
import { updateProfileModal } from "store/slices/authSlice";
import TextArea from "antd/lib/input/TextArea";
import Autocomplete from "react-google-autocomplete";
import _ from "lodash";
import AuthService from "services/AuthService";
import UserService from "services/UserService";
import UploadFileService from "services/UploadFileService";
import JoditEditorComponent from "components/jodit-editor/JoditEditor";

function ProfileModal({ showModal, refetchList, selectedRow, setVerifyModal }) {
  const { Option } = Select;
  const [submitLoading, setSubmitLoading] = useState(false);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth);
  console.log("444 user", user);
  const [profileImages, setProfileImages] = useState([]);
  const [locationDisplayValue, setLocationDisplayValue] = useState("");
  const autocompleteRef = useRef(null);

  // Initialize location display value when form loads
  useEffect(() => {
    const currentLocation = form.getFieldValue("location");
    if (currentLocation) {
      if (typeof currentLocation === "object" && currentLocation.locationName) {
        setLocationDisplayValue(currentLocation.locationName);
      } else if (typeof currentLocation === "string") {
        setLocationDisplayValue(currentLocation);
      }
    }
  }, [form, showModal]);

  // Add input event listener to capture manual typing
  useEffect(() => {
    if (autocompleteRef.current && showModal) {
      const inputElement = autocompleteRef.current;

      const handleInput = (e) => {
        const value = e.target.value;
        setLocationDisplayValue(value);
        // Store string value when user is typing manually
        form.setFieldsValue({ location: value });
      };

      inputElement.addEventListener("input", handleInput);

      return () => {
        inputElement.removeEventListener("input", handleInput);
      };
    }
  }, [showModal, form]);

  // useEffect(() => {
  //   // When the modal is opened, set the initial values for the form-prefill form
  //   if (selectedRow) {
  //     console.log("Prefilling form with selected row:", selectedRow);
  //     form.setFieldsValue({
  //       status: selectedRow.status || null,
  //       remarks: selectedRow?.remarks || "",
  //     });
  //   }
  // }, [selectedRow, form]);

  // const handleOk = async (values) => {
  //   setSubmitLoading(true);
  //   try {
  //     form.validateFields()
  //     const response = await dateChangeService.put(selectedRow._id, values);
  //     console.log('response after', response)
  //     if(response?.success){
  //       notification.success({message:"Profile data updated successfully."});
  //         dispatch(updateProfileModal(false));

  //     // refetchList();
  //     form.resetFields();
  //     }
  //     // Checking if the response status is OK (status code 200-299)
  //     if (!response.ok) {
  //       throw new Error(`HTTP error! Status: ${response.status}`);
  //     }

  //     // Parse the JSON data from the response
  //     // const data = await response.json();

  //     // Handle the fetched data here, e.g., setState or any further processing
  //   } catch (error) {
  //     // Catch and log any error that occurs during the API call
  //     console.error("Error occurred while fetching data:", error.message);
  //   }

  //   setSubmitLoading(false);
  // };

  const uploadToAWS = async (file) => {
    console.log("file to upload", file);

    let url = null;

    if (!UploadFileService.validURL(file?.url) && file?.url?.includes("blob")) {
      url = await UploadFileService.getImageUrl(file.originFileObj);
      console.log("uploaded file and got url", url);
      return url;
    } else return file.url;
  };

  const handleOk = async () => {
    const formImages = form.getFieldValue("images");
    form
      .validateFields()
      .then(async (values) => {
        setSubmitLoading(true);
        // if (formImages?.length == 0) {
        //   notification.error({
        //     message: "Add atleast one image",
        //   });
        //   setSubmitLoading(false);
        //   return;
        // }

        if (
          formImages?.length > 0 &&
          !formImages?.some((item) => item.mainImage == "Yes")
        ) {
          notification.error({
            message: "Select a main image from images!",
          });
          setSubmitLoading(false);
          return;
        }

        console.log("values before conversion", values);

        // values = _.mapValues(values, (value) => (value === "" ? null : value));

        if (formImages?.length > 0) {
          values.images = await Promise.all(
            formImages.map(async (obj, i) => {
              let imageData = obj;
              const responseUrl = await uploadToAWS(obj.url[0]);
              if (responseUrl) {
                imageData.url = responseUrl;
                // imageData.url = responseUrl?.original || responseUrl?.url;
                imageData.thumbnail = responseUrl;
                // imageData.thumbnail = responseUrl?.thumbnail;
                imageData.mainImage = obj.mainImage;
                imageData.imageTag = obj.imageTag;
                // delete imageData.image
              }
              return imageData;
            }),
          );
        } else {
          // values.images = [
          //   { url: null, mainImage: null, thumbnail: null, imageTag: null },
          // ];
          values.images = [];
        }

        if (profileImages?.length > 0) {
          let profileImageArray = await Promise.all(
            profileImages.map(async (obj, i) => {
              // let imageData = obj;
              const responseUrl = await uploadToAWS(obj);
              return responseUrl;
            }),
          );
          values.profileImage = profileImageArray[0];
        } else {
          values.profileImage = null;
        }

        delete values["imageTag"];

        values.email = user?.userDetails?.email;
        values.name = user?.userDetails?.name;
        values.phoneNo = user?.userDetails?.phoneNo;
        values.type = user?.userDetails?.type;

        // Ensure location is in the correct format
        if (values.location && typeof values.location === "object") {
          // Location is already in the correct format from locationFinder
          console.log("Location payload:", values.location);
        } else if (values.location && typeof values.location === "string") {
          // If location is still a string, convert it to the required format
          // Note: This won't have lat/lng data, so it's a fallback
          values.location = {
            longitude: null,
            latitude: null,
            locationName: values.location,
          };
        }

        const created = await UserService.profileEdit(values);
        if (created) {
          console.log(created);
          notification.success({
            message: created.message || "Profile data updated sucessfully.",
          });
          dispatch(updateProfileModal(false));
        } else {
          // notification.error({
          //   message: "Error",
          //   description:
          //     "Failed to create Page",
          // });
        }

        setSubmitLoading(false);
      })
      .catch((info) => {
        console.log("adding error", info);
        setSubmitLoading(false);
        message.error("Please enter all required fields.");
      });
  };

  const handleCancel = () => {
    dispatch(updateProfileModal(false));
    form.resetFields();
    setLocationDisplayValue("");
  };

  const locationFinder = (place) => {
    console.log("place is", place);
    if (place.geometry && place.geometry.location) {
      const latitude = place.geometry.location.lat();
      const longitude = place.geometry.location.lng();
      const formattedAddress = place.formatted_address;

      // Create location object in the required format
      const locationData = {
        longitude: longitude,
        latitude: latitude,
        locationName: formattedAddress,
      };

      console.log("Location data:", locationData);

      // Update the form value with location object
      form.setFieldsValue({
        location: locationData,
      });

      // Update display value for reference
      setLocationDisplayValue(formattedAddress);
    }
  };

  return (
    <Modal
      open={showModal}
      title="Add Profile Details"
      onOk={handleOk}
      onCancel={handleCancel}
      footer={null}
      width={window.innerWidth > 1024 ? "70vw" : "80vw"}
    >
      <Form
        name="basic"
        form={form}
        // labelCol={{ span: 8 }}
        // wrapperCol={{ span: 16 }}
        initialValues={{ remember: true }}
        onFinish={handleOk}
        autoComplete="off"
        layout="vertical"
      >
        <Form.Item label="Profile Image" name="profileImage">
          <ImageUploader
            defaultFileList={profileImages || []}
            width={400}
            height={220}
            onChange={(newFileList) => {
              setProfileImages(newFileList);
            }}
            recommendedSize="400px * 220px"
          />
        </Form.Item>
        {/* <Form.Item name="location" label="Location">
          <Input placeholder="Location" />
        </Form.Item> */}
        <div style={{ marginBottom: "24px" }}>
          <label
            style={{
              display: "block",
              marginBottom: "8px",
              color: "rgba(0, 0, 0, 0.85)",
              fontSize: "14px",
              fontWeight: "500",
            }}
          >
            Location
          </label>
          <Autocomplete
            ref={autocompleteRef}
            className="custom-autocomplete"
            style={{
              width: "100%",
              borderRadius: "10px",
              height: "40px",
              padding: "8.5px 11px",
              border: "1px solid #e6ebf1",
              fontSize: "14px",
              color: "#455560",
            }}
            apiKey="AIzaSyBucHHSLvAcbRq3CWGkRzzdYo7Da8hIzCQ"
            onPlaceSelected={locationFinder}
            defaultValue={locationDisplayValue}
            placeholder="Search for a location..."
            options={{
              // Try searching all place types, not just addresses
              types: ["establishment", "geocode"], // Use 'establishment' to include businesses like "Lulu"
              fields: [
                "name",
                "formatted_address",
                "geometry",
                "address_components",
                "place_id",
                "vicinity",
              ], // 👈 ADD THIS
              componentRestrictions: { country: "in" }, // just prioritize indian locations
            }}
          />
        </div>

        {/* Hidden form item to store location data */}
        <Form.Item name="location" style={{ display: "none" }}>
          <Input />
        </Form.Item>

        <h5>Portfolio Images</h5>
        <Form.List name="images">
          {(fields, { add, remove }) => (
            <>
              <div className="image-card-row-wrapper">
                {fields.map((field, index) => (
                  <Card
                    key={field.key}
                    className="pages-images-card"
                    style={{ position: "relative" }}
                    // extra={
                    //   <Button
                    //     type="text"
                    //     danger
                    //     icon={<CloseCircleOutlined />}
                    //     onClick={() => remove(field.name)}
                    //   >
                    //     Remove
                    //   </Button>
                    // }
                  >
                    <Button
                      type="text"
                      className="image-card-close-pages"
                      danger
                      icon={<CloseCircleOutlined />}
                      onClick={() => remove(field.name)}
                    >
                      Remove
                    </Button>

                    <div className="col-flex">
                      <Row
                        gutter={8}
                        style={{ display: "flex", flexDirection: "column" }}
                      >
                        <Col xs={24} sm={24} md={24} lg={24}>
                          {/* Image Upload Field */}
                          <Form.Item
                            {...field}
                            name={[field.name, "url"]}
                            label="Image"
                            valuePropName="fileList"
                            getValueFromEvent={(e) => e}
                            rules={[
                              {
                                required: true,
                                message: "Please upload an image!",
                              },
                            ]}
                          >
                            <ImageUploader
                              defaultFileList={
                                form.getFieldValue("images")?.[field.name]
                                  ?.url || []
                              }
                              width={1200}
                              height={800}
                              recommendedSize="1200px * 800px"
                              fieldName={field.name}
                              onChange={(newFileList) => {
                                form.setFieldValue(
                                  ["images", field.name, "url"],
                                  newFileList,
                                );
                              }}
                            />
                          </Form.Item>
                        </Col>

                        <Col xs={24} sm={24} md={24} lg={24}>
                          <div
                            className="row-flex"
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              gap: "5px",
                            }}
                          >
                            <Form.Item
                              {...field}
                              label="Tag"
                              name={[field.name, "imageTag"]}
                              rules={[
                                {
                                  required: false,
                                  message: "Please input a tag!",
                                },
                              ]}
                              style={{ width: "100%" }}
                            >
                              <Input placeholder="Tag" className="w-100" />
                            </Form.Item>
                            {/* <Form.Item>
                              <Button
                                onClick={() => remove(field.name)}
                                style={{ marginTop: "30px", color: "red" }}
                              >
                                <CloseCircleOutlined />
                              </Button>
                            </Form.Item> */}
                          </div>

                          {/* Main Image Field */}
                          <Form.Item
                            {...field}
                            label="Main Image or not"
                            name={[field.name, "mainImage"]}
                            rules={[
                              {
                                required: true,
                                message:
                                  "Please select whether this image is main image or not!",
                              },
                              {
                                validator: (_, value) => {
                                  const imageArrayInForm = form
                                    .getFieldValue("images")
                                    ?.filter((_, idx) => idx !== field.name);
                                  if (
                                    value === "Yes" &&
                                    imageArrayInForm?.some(
                                      (item) => item.mainImage === "Yes",
                                    )
                                  ) {
                                    notification.error({
                                      message:
                                        "You can select only one image as Main image!",
                                    });
                                    return Promise.reject(
                                      new Error("Invalid selection"),
                                    );
                                  }
                                  return Promise.resolve();
                                },
                              },
                            ]}
                            initialValue="No"
                            style={{ width: "100%" }}
                          >
                            <Select
                              showSearch
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                option?.children
                                  ?.toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                              placeholder="Main Image or not"
                            >
                              <Select.Option value="Yes">Yes</Select.Option>
                              <Select.Option value="No">No</Select.Option>
                            </Select>
                          </Form.Item>
                        </Col>
                      </Row>
                    </div>
                  </Card>
                ))}
              </div>
              {/* Add Image Button */}
              <Form.Item>
                <Button
                  style={{ width: "100%" }}
                  type="dashed"
                  onClick={() => {
                    add();
                  }}
                  block
                  icon={<PlusOutlined />}
                >
                  Add Image
                </Button>
              </Form.Item>
            </>
          )}
        </Form.List>
        <Form.Item
          name="description"
          label="Description"
          rules={[
            { required: false, message: "Please add profile description" },
          ]}
        >
          <JoditEditorComponent
            //placeholder="Write something..."
            onChange={(e) => {
              // storeData("description", e);
              form.setFieldsValue({ description: e });
            }}
            value={form.getFieldValue("description") || ""}
            disabled={false}
          />
        </Form.Item>

        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button loading={submitLoading} type="primary" htmlType="submit">
              Submit
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default ProfileModal;
